window.theme = window.theme || {};
document.addEventListener('variant:change', function (evt) {
  var variant = evt.detail.variant
  if (variant.compare_at_price > variant.price) {
    var savings = variant.compare_at_price - variant.price;
    savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
    $('.product__price-savings').removeClass('hide').html('Save ' + savings);

  } else {
    $('.product__price-savings').addClass('hide');
  }
});

let giftPopup = document.querySelector('.cart__gift--popup');
if (giftPopup) {
  giftPopup.addEventListener('click', function () {
    var giftModalHtml = '<div class="cart__modal" style="z-index: 9999999999;">' +
      '<div class="cart__modal--content">' +
      '<img src="https://cdn.shopify.com/s/files/1/0065/2266/7092/products/kisslove-hair-free-gift-packs-6_720x.jpg">' +
      '<div class="cart__modal--close"><i class="icon--close"></i></div>' +
      '</div>' +
      '</div>';
    document.querySelector('body').insertAdjacentHTML("beforeend", giftModalHtml);
    document.querySelector('.cart__modal').addEventListener('click', function (e) { e.target == this && document.querySelector('.cart__modal').remove(); });
    document.querySelector('.cart__modal--close').addEventListener('click', function () { document.querySelector('.cart__modal').remove(); });
  });
}

let timerContainer = document.querySelectorAll('.flashdeal-timer');
if (timerContainer.length) {
  var countdownInterval = setInterval(countdown, 1000);
}
function countdown() {
  let now = new Date();
  let hours = 23 - now.getHours();
  let minutes = 59 - now.getMinutes();
  let seconds = 59 - now.getSeconds();

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  let countdownTimer = '<span class="fdt-end">End In:</span>' + '<span class="fdt-hour">' + hours + "</span>" + ":" + '<span class="fdt-min">' + minutes + "</span>" + ":" + '<span class="fdt-second">' + seconds + "</span>";

  document.querySelectorAll(".flashdeal-timer").forEach((item) => {
    item.innerHTML = countdownTimer;
  })

  if (hours == 0 && minutes == 0 && seconds == 0) {
    clearInterval(countdownInterval);
    countdown();
  }
}

function initLazyScript(element, callback, threshold = 500) {
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof callback === 'function') {
            callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, { rootMargin: `0px 0px ${threshold}px 0px` });

    io.observe(element);
  } else {
    callback();
  }
}

class CarouselSlider extends HTMLElement {
  constructor() {
    if (super(),
      this.slides = [...this.querySelectorAll(".collection-block:not([hidden])")],
      this.slides.length < 2) {
      this.setCarouselState(!1);
      return
    }

    window.initLazyScript(this, this.init.bind(this))
  }
  init() {
      this.slider = this.querySelector(".slider-custom"),
      this.grid = this.querySelector(".slider__grid"),
      this.nav = this.querySelector(".slider-nav"),
      this.rtl = document.dir === "rtl",
      this.nav && (this.prevBtn = this.querySelector('button[name="prev"]'),
      this.nextBtn = this.querySelector('button[name="next"]')),
      this.initSlider(),
      window.addEventListener("on:debounced-resize", this.handleResize.bind(this)),
      this.setAttribute("loaded", "")
  }
  initSlider() {
    this.gridWidth = this.grid.clientWidth;

    // Distance between leading edges of adjacent slides (i.e. width of card + gap).
    this.slideSpan = this.getWindowOffset(this.slides[1]) - this.getWindowOffset(this.slides[0]);

    // Note: Slide can re-initialise after previous use
    this.currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan) || 0;

    // Width of gap between slides.
    this.slideGap = this.slideSpan - this.slides[0].clientWidth;

    this.slidesPerPage = Math.round((this.gridWidth + this.slideGap) / this.slideSpan);
    this.slidesToScroll = theme.settings.sliderItemsPerNav === 'page' ? this.slidesPerPage : 1;
    this.totalPages = this.slides.length - this.slidesPerPage + 1;

    this.setCarouselState(this.totalPages > 1);
    this.addListeners();
    if (this.totalPages < 2 || !this.nav) return;

    this.sliderStart = this.getWindowOffset(this.slider);
    if (!this.sliderStart) this.sliderStart = (this.slider.clientWidth - this.gridWidth) / 2;
    this.sliderEnd = this.sliderStart + this.gridWidth;
    this.setButtonStates();
  }
  refresh() {
    if (this.hasAttribute("loaded") && (this.removeListeners(),
      this.style.removeProperty("--current-slide-height")),
      this.slides = [...this.querySelectorAll(".slider__item:not([hidden])")],
      this.slides.length < 2) {
      this.setCarouselState(!1);
      return
    }
    this.init()
  }
  addListeners() {
    this.scrollHandler = theme.utils.debounce(100, this.handleScroll.bind(this)),
      this.slider.addEventListener("scroll", this.scrollHandler),
      this.nav && (this.navClickHandler = this.handleNavClick.bind(this),
        this.nav.addEventListener("click", this.navClickHandler)),
      window.matchMedia("(pointer: fine)").matches && (this.mousedownHandler = this.handleMousedown.bind(this),
        this.mouseupHandler = this.handleMouseup.bind(this),
        this.mousemoveHandler = this.handleMousemove.bind(this),
        this.slider.addEventListener("mousedown", this.mousedownHandler),
        this.slider.addEventListener("mouseup", this.mouseupHandler),
        this.slider.addEventListener("mouseleave", this.mouseupHandler),
        this.slider.addEventListener("mousemove", this.mousemoveHandler))
  }
  removeListeners() {
    this.slider.removeEventListener("scroll", this.scrollHandler),
      this.nav && this.nav.removeEventListener("click", this.navClickHandler),
      window.matchMedia("(pointer: fine)").matches && (this.slider.removeEventListener("mousedown", this.mousedownHandler),
        this.slider.removeEventListener("mouseup", this.mouseupHandler),
        this.slider.removeEventListener("mouseleave", this.mouseupHandler),
        this.slider.removeEventListener("mousemove", this.mousemoveHandler))
  }
  handleScroll() {
    this.currentIndex = Math.round(Math.abs(this.slider.scrollLeft) / this.slideSpan),
      this.nav && this.setButtonStates();
    this.scrollToElement(this.slides[this.currentIndex])
  }
  handleMousedown(evt) {
    this.mousedown = !0,
      this.startX = evt.pageX - this.sliderStart,
      this.scrollPos = this.slider.scrollLeft,
      this.slider.classList.add("is-grabbing")
  }
  handleMouseup() {
    this.mousedown = !1,
      this.slider.classList.remove("is-grabbing")
  }
  handleMousemove(evt) {
    if (!this.mousedown)
      return;
    evt.preventDefault();
    const x = evt.pageX - this.sliderStart;
    this.slider.scrollLeft = this.scrollPos - (x - this.startX) * 2
  }
  handleNavClick(evt) {

    if (!evt.target.matches('.slider-nav__btn')) return;

    if ((evt.target.name === 'next' && !this.rtl) || (evt.target.name === 'prev' && this.rtl)) {
      this.scrollPos = this.slider.scrollLeft + (this.slidesToScroll * this.slideSpan);
    } else {
      this.scrollPos = this.slider.scrollLeft - (this.slidesToScroll * this.slideSpan);
    }
    if (this.scrollPos < this.slideSpan) {
      this.scrollPos = 0
    }
    this.slider.scrollTo({ left: this.scrollPos, behavior: 'smooth' });
  }
  handleResize() {
    this.nav && this.removeListeners(),
      this.initSlider()
  }
  scrollToElement(el, transition) {
    if (this.slider.classList.contains('is-grabbing')) {

      this.scrollPos = el.offsetLeft;
      if (this.scrollPos < this.slideSpan) {
        this.scrollPos = 0
      }
      console.log(el.offsetLeft)
      this.slider.scrollTo({ left: this.scrollPos, behavior: transition || 'smooth' });
    }
  }
  getWindowOffset(el) {
    return this.rtl ? window.innerWidth - el.getBoundingClientRect().right : el.getBoundingClientRect().left
  }
  getSlideVisibility(el) {
    const slideStart = this.getWindowOffset(el);
    const slideEnd = Math.floor(slideStart + this.slides[0].clientWidth);
    return slideStart >= this.sliderStart && slideEnd <= this.sliderEnd;
  }
  setCarouselState(active) {
    active ? (this.removeAttribute("inactive"),
      this.gridWidth !== this.grid.clientWidth && this.handleBreakpointChange()) : this.setAttribute("inactive", "")
  }
  setButtonStates() {
    this.prevBtn.disabled = this.getSlideVisibility(this.slides[0]) && this.slider.scrollLeft === 0;
    this.nextBtn.disabled = this.getSlideVisibility(this.slides[this.slides.length - 1])
  }
}
customElements.define("carousel-slider", CarouselSlider);

class ExpandSet extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('mouseover', this.onMouseOverHandler.bind(this));
  }
  onMouseOverHandler() {
    if (this.classList.contains('active')) return;
    Array.from(this.closest('.shopify-section').querySelectorAll('expand-set')).map((item) => {
      item.classList.remove('active');
    });
    this.classList.add('active');
  }
}
customElements.define('expand-set', ExpandSet);
